<div class="wizard-progress-container">
	
	@if (!wizardStarted) {
		<div class="wizard-intro">
			<h1>I’m excited to help make your house feel more like your dream home! Before our meeting, please answer the questions below to help me better understand your home goals and design
			    style. </h1>
			<button class="nlv-btn" (click)="onStartConsultation()">Start Consultation</button>
		</div>
	}
	
	@if (wizardStarted) {
		<div class="progress-items">
			
			<!--<ng-container *ngComponentOutlet="activeStep.component; inputs: {question: activeStep}"></ng-container>-->
			
			<!--Contact Questions-->
			@if (currentStep === 0) {
				<app-contact-details [question]="activeStep"></app-contact-details>
			}
			
			<!--Survey Questions-->
			@if (currentStep > 0 && currentStep < progressSteps.length - 1) {
				<app-question [question]="activeStep"></app-question>
			}
			
			<!--Completed Survey-->
			@if (currentStep === progressSteps.length - 1) {
				<app-wizard-completed></app-wizard-completed>
			}
			
			<!--Progress Bar-->
			@if (currentStep < progressSteps.length - 1) {
				<div class="progress-footer">
					<div class="progress-tracker">
						<div class="step-counter">{{ 'Question ' + ( currentStep + 1 ) + ' of ' + ( progressSteps.length - 1 ) }}</div>
						<div class="progress-bar">
							<div class="bar-whole"></div>
							<div class="bar-progress" [ngStyle]="{'width': getProgressAmount() }"></div>
						</div>
					</div>
					<div class="navigation-controls">
						<div class="control-buttons" [ngStyle]="getNavigationStyles()">
							@if (currentStep > 0) {
								<button class="nlv-btn" (click)="onPreviousStep()">Previous</button>
							}
							<button class="nlv-btn" (click)="onNextStep()">{{ currentStep === progressSteps.length - 2 ? 'Complete Survey' : 'Next' }}</button>
						</div>
						<div class="exit-link-container">
							<button class="nlv-btn link" (click)="onExitConsultation()">Exit Questionnaire</button>
						</div>
					</div>
				</div>
			}
		
		</div>
	}

</div>
